import React, { Component } from 'react';

const BOOKMARKLET_SCRIPT =
    "javascript:(function(){if(sessionStorage.getItem('sbem-preview')){sessionStorage.removeItem('sbem-preview');}else{sessionStorage.setItem('sbem-preview','1');}location.reload();})();";

const COPY_RESET_DELAY_MS = 2000;

class BookmarkletPreviewSection extends Component {
    constructor(props) {
        super(props);
        this.state = { copied: false };
        this._copyResetTimer = null;
    }

    componentWillUnmount() {
        if (this._copyResetTimer) {
            clearTimeout(this._copyResetTimer);
        }
    }

    handleCopy = () => {
        if (typeof navigator !== 'undefined' && navigator.clipboard) {
            navigator.clipboard.writeText(BOOKMARKLET_SCRIPT).catch(() => {});
        } else if (typeof document !== 'undefined' && document.body) {
            // Fallback: use a temporary textarea when the clipboard API is unavailable
            // (e.g. HTTP/non-secure contexts where navigator.clipboard is undefined)
            const textarea = document.createElement('textarea');
            textarea.value = BOOKMARKLET_SCRIPT;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.focus();
            textarea.select();
            try {
                document.execCommand('copy');
            } catch (_) {
                // copy failed silently
            }
            document.body.removeChild(textarea);
        }
        // Neither the clipboard API nor the DOM is available (e.g. SSR) — no-op.

        this.setState({ copied: true });
        clearTimeout(this._copyResetTimer);
        this._copyResetTimer = setTimeout(() => {
            this.setState({ copied: false });
        }, COPY_RESET_DELAY_MS);
    };

    render() {
        const { copied } = this.state;

        return (
            <div className="in-context-bookmarklet-section">
                <h4 className="top-margin">Preview on Your Site</h4>
                <p className="spark-message__content status-message px-0">
                    Your in-context booking components are staged — they are published to your website but hidden from
                    visitors. To preview them on your live site, drag the button below to your browser&apos;s bookmarks
                    bar, then visit your website and click it. Click it again to return to the visitor view. Preview
                    mode is active only for your current browser session.
                </p>
                <div className="in-context-bookmarklet-drag-row top-margin">
                    {/* Drag target — the bookmarklet href is the toggle script */}
                    <a
                        href={BOOKMARKLET_SCRIPT}
                        className="spark-btn spark-btn--secondary spark-btn--sm in-context-bookmarklet-drag-target"
                        onClick={e => e.preventDefault()}
                        draggable="true"
                    >
                        Toggle In-Context Preview
                    </a>
                </div>
                <div className="in-context-bookmarklet-code-wrapper top-margin">
                    <code className="in-context-bookmarklet-code">{BOOKMARKLET_SCRIPT}</code>
                    <button
                        className="spark-btn spark-btn--secondary spark-btn--sm in-context-bookmarklet-copy-btn"
                        onClick={this.handleCopy}
                        type="button"
                    >
                        {copied ? 'Copied!' : 'Copy Bookmarklet'}
                    </button>
                </div>
            </div>
        );
    }
}

export { BOOKMARKLET_SCRIPT };
export default BookmarkletPreviewSection;



// WEBPACK FOOTER //
// ./src/components/pages/pages/product/BookmarkletPreviewSection.js